import { adminHttpClient } from '../../../../../commons/adminHttpClient'

export interface EndDatePerkTypeRequest {
  finalEndDate: string
  runOutDays: number
  expenseCategoryId: number
  productClassId: string
}
const setPerkEndDate = (request: EndDatePerkTypeRequest) => {
  return adminHttpClient.post('/AdminDashboard/Perks/EndPerk', request)
}

export default setPerkEndDate
